module.exports = __webpack_public_path__ + "img/ico_select.739e6aa3.svg";